import SmartAlertTemplate from '@/components/SmartAlertTemplate';
import { smartAlertPageMap } from '@/data/smartAlertPages';

const page = smartAlertPageMap['personal-information'];

if (!page) {
  throw new Error('Smart alert data missing for personal information');
}

const SmartAlertPersonalInformation = () => {
  return <SmartAlertTemplate page={page} />;
};

export default SmartAlertPersonalInformation;


